import { Form } from 'antd';
import { seriesService } from 'content/service';
import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import * as Component from '../../../../shared/components';
import { SeriesInterface } from '../../type/seriesType';
import * as SeriesComponent from '../components';
import { SeriesEditHandlers } from '../handlers/SeriesEditHandlers';

const SeriesEdit: React.FC = () => {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [series, setSeries] = useState<SeriesInterface | undefined>();
  const { id } = useParams();
  const [, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { fetchedSeries } = await SeriesEditHandlers(Number(id));
      setSeries(fetchedSeries);
    };
    fetchData().then(() => {
      setIsLoading(false);
    });

    const fetchSeries = async (): Promise<void> => {
      const series = await seriesService.fetchById(Number(id));
      if (series) {
        setSeries(series);
        const formattedSeries = {
          ...series,
          release_date_start: series.release_date_start ? dayjs(series.release_date_start) : null,
          release_date_end: series.release_date_end ? dayjs(series.release_date_end) : null,
          produce_country: series.produce_country,
        };
        form.setFieldsValue(formattedSeries);
      }
    };
    fetchSeries().then(() => {
      setIsLoading(false);
    });
  }, [id, form]);

  const components = [
    {
      key: 'detail',
      title: 'Detail',
      component: (
        <SeriesComponent.SeriesDetailComponent
          form={form}
          series={series || undefined}
          actionTitle="SAVE"
        />
      ),
    },
    {
      key: 'poster',
      title: 'Poster',
      component: (
        <SeriesComponent.PosterComponent
          seriesId={Number(id)}
          uploadedPosterList={series?.posters || []}
        />
      ),
    },
    {
      key: 'season',
      title: 'Season',
      component: (
        <SeriesComponent.SeasonListComponent
          seriesId={Number(id)}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      ),
    },
  ];

  return (
    <Component.BasePageComponent>
      <Component.TapComponent
        components={components}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    </Component.BasePageComponent>
  );
};

export default observer(SeriesEdit);
